import { withForm } from '@components/ui/form/form';
import { useGetCategories } from '@queries/category.query';
import { mapToSelectOptions } from '@utils/select.util';
import { useMemo } from 'react';
import { technologyFormOptions } from './technology-form-options';

export const InformationStep = withForm({
  ...technologyFormOptions,
  render: function Render({ form }) {
    const { data: categories } = useGetCategories();
    const categoryOptions = useMemo(() => mapToSelectOptions(categories ?? []), [categories]);

    return (
      <form.AppForm>
        <div className="flex w-full flex-col gap-4">
          <form.AppField name="name">
            {(field) => (
              <field.TextField
                data-1p-ignore
                autoComplete="off"
                label="Name"
                required
                type="text"
              />
            )}
          </form.AppField>
          <form.AppField name="categoryId">
            {(field) => (
              <field.SelectPopoverField
                className="w-full"
                emptyMessage="No technology category found"
                label="Category"
                options={categoryOptions}
                placeholder="Select"
                required
                searchPlaceholder="Search technology category..."
              />
            )}
          </form.AppField>
          <form.AppField name="subcategoryId">
            {(field) => (
              <form.Subscribe selector={(state) => ({ categoryId: state.values.categoryId })}>
                {({ categoryId }) => {
                  const selectedCategory = categories?.find((cat) => cat.id === categoryId);
                  const subcategoryOptions = mapToSelectOptions(selectedCategory?.subcategories ?? []);
                  return (
                    <field.SelectPopoverField
                      className="w-full"
                      disabled={!categoryId}
                      emptyMessage="No technology subcategory found"
                      label="Subcategory"
                      options={subcategoryOptions}
                      placeholder="Select"
                      required
                      searchPlaceholder="Search technology subcategory..."
                    />
                  );
                }}
              </form.Subscribe>
            )}
          </form.AppField>
          <form.AppField name="description">
            {(field) => (
              <field.TextAreaField
                label="Description"
                textareaClassName="flex h-28 w-full rounded-lg bg-gray-100 p-3"
              />
            )}
          </form.AppField>
        </div>
      </form.AppForm>
    );
  },
});
